<template>
  <div>
    <b-modal :id="`FormLancamento`"
             :ref="`FormLancamento`"
             no-close-on-backdrop
             no-close-on-esc
             class="FormLancamento"
             header-class="FormLancamento_header"
             body-class="FormLancamento_body"
             content-class="FormLancamento_content"
             size="xl"
             visible>
      <template slot="modal-header">
        <div>
          <b class="ml-2">{{ propLancamento ? 'Editar lançamento' : 'Novo lançamento' }}</b>
        </div>
      </template>
      <div class="row">
        <div class="col-2 pl-0">
          <label for="data">Data do lançamento</label>
          <input id="data"
                 v-model="localData.data_lancamento"
                 v-validate="'required'"
                 type="date"
                 name="data_lancamento"
                 class="form-control form-control-sm"
                 :class="{'is-invalid' : errors.has('data_lancamento')}">
          <small class="invalid-feedback">{{ errors.first('data_lancamento') }}</small>
        </div>
        <div class="col-2">
          <label for="tipo">Tipo de lançamento</label>
          <div class="row">
            <div class="col-6">
              <b-form-radio v-model="localData.tipo"
                            name="some-radios"
                            :disabled="!!propLancamento"
                            value="DESPESA"
                            @change="changeTipo">
                Despesa
              </b-form-radio>
            </div>
            <div class="col-6 pl-4">
              <b-form-radio v-model="localData.tipo"
                            name="some-radios"
                            :disabled="!!propLancamento"
                            value="RECEITA"
                            @change="changeTipo">
                Receita
              </b-form-radio>
            </div>
          </div>
        </div>
      </div>
      <div v-if="localData.tipo === 'DESPESA'"
           class="row mt-2">
        <div class="col-6 pl-0">
          <label for="categoria">Categoria</label>
          <v-select v-model="localData.categoria"
                    :options="categoriasFiltered"
                    label="nome"
                    :class="{ 'is-invalid': errors.has('categoria') }"
                    class="form-control form-control-sm"
                    name="categoria"
                    taggable
                    @input="changeCategoria" />
        </div>
        <div class="col-6 pr-0">
          <label for="beneficiario">Beneficiário</label>
          <div class="d-flex">
            <v-select v-model="localData.fornecedor"
                      label="nome"
                      :options="fornecedoresFiltered"
                      :class="{ 'is-invalid': errors.has('fornecedor') }"
                      class="form-control form-control-sm"
                      name="fornecedor"
                      taggable
                      @input="changeBeneficiario" />
            <button v-b-tooltip.hover.right="'Adicionar Beneficiário'"
                    class="btn btn-sm btn-primary ml-1"
                    @click="showFormBeneficiario = true">
              <IconSvg class="icon-add"
                       icon="add" />
            </button>
          </div>
        </div>
      </div>
      <div v-else
           class="row mt-2">
        <div class="col-6 pl-0">
          <label for="categoria">Tipo de ato</label>
          <v-select id="categoria"
                    v-model="localData.categoria"
                    :options="categoriasFiltered"
                    label="nome"
                    :class="{ 'is-invalid': errors.has('categoria') }"
                    class="form-control form-control-sm"
                    name="categoria"
                    taggable
                    @input="changeCategoria" />
        </div>
        <div class="col-6 pl-0">
          <label for="categoria">Ato</label>
          <v-select id="categoria"
                    v-model="localData.categoria.ato"
                    :options="atos"
                    :class="{ 'is-invalid': errors.has('ato') }"
                    class="form-control form-control-sm"
                    name="ato"
                    taggable
                    @input="changeAto" />
        </div>
      </div>
      <div class="row mt-2">
        <div v-if="localData.tipo === 'DESPESA'"
             class="col-3 pl-0">
          <label for="numero_documento">Número de Documento</label>
          <input id="numero_documento"
                 v-model="localData.numero_documento"
                 type="text"
                 class="form-control form-control-sm">
        </div>
        <div class="col-6"
             :class="{'pl-0': localData.tipo === 'RECEITA'}">
          <label for="detalhamento">Detalhamento</label>
          <input id="detalhamento"
                 v-model="localData.detalhamento"
                 :class="{ 'is-invalid': errors.has('detalhamento') }"
                 type="text"
                 name="detalhamento"
                 class="form-control form-control-sm">
          <small class="invalid-feedback">{{ errors.first('detalhamento') }}</small>
        </div>
        <div v-if="localData.tipo === 'RECEITA'"
             class="col-1">
          <label for="atos">Atos</label>
          <input id="atos"
                 v-model="localData.atos"
                 type="number"
                 min="1"
                 class="form-control form-control-sm">
        </div>
        <div class="col-2 pr-0">
          <label for="valor">Valor total</label>
          <input id="valor"
                 v-model="localData.valor"
                 v-validate="'required'"
                 v-money="money"
                 name="valor"
                 class="form-control form-control-sm"
                 size="sm"
                 required
                 trim>
          <small class="invalid-feedback">{{ errors.first('valor') }}</small>
        </div>
      </div>
      <div v-if="localData.tipo === 'DESPESA'">
        <div v-if="localData.livroCaixaLancamentoArquivo.length">
          <div class="row mt-3">
            <div v-for="(documento, index) in localData.livroCaixaLancamentoArquivo"
                 :key="index">
              <Documento :prop-documento="documento.pdf ? documento.pdf : documento"
                         :prop-index="index"
                         @deleteDocumento="deleteDocumento" />
            </div>
          </div>
        </div>
        <div v-if="showFile ">
          <div class="row mt-3">
            <div class="col-8 pl-0">
              <div class="DropArea AdicionarImagem--border d-flex justify-content-center align-items-center">
                <div>
                  <span>
                    Arraste o arquivo PDF aqui ou <label for="preparar-processo-imagem"><u>procure manualmente</u></label> para upload
                  </span>
                </div>
              </div>

              <input v-show="showFile"
                     id="preparar-processo-imagem"
                     v-validate="{mimes: ['application/pdf']}"
                     type="file"
                     name="livroCaixaLancamentoArquivo"
                     :class="['form-control-sm form-control-file fileObrigatorio']"
                     accept="application/pdf"
                     multiple
                     @dragover="($event) => dragArea($event)"
                     @dragleave="($event) => dragAreaOut($event)"
                     @drop="drop()"
                     @change="addArquivo">

              <div v-if="errors.has(`documento`)"
                   class="text-center">
                <small class="text-danger">Certifique-se de estar escolhendo um documento <strong>PDF</strong></small>
              </div>
            </div>
          </div>
        </div>
        <div class="row mt-3">
          <button class="btn btn-sm btn-primary px-5"
                  :disabled="showFile"
                  @click="showFile = true">
            <icon-svg icon="add"
                      class="icon-add icon--sm mr-1" />
            Adicionar mais imagens
          </button>
        </div>
      </div>
      <template slot="modal-footer">
        <button class="btn btn-sm btn-light px-3"
                @click="hide()">
          Voltar
        </button>
        <button v-if="propLancamento"
                class="btn btn-sm btn-secondary"
                @click="atualizarLancamento()">
          Salvar
        </button>
        <b-dropdown v-else
                    size="sm"
                    right
                    split
                    text="Salvar item"
                    @click="saveLancamento(true)">
          <b-dropdown-item @click="saveLancamento(true)">
            Salvar item
          </b-dropdown-item>
          <b-dropdown-item @click="saveLancamento(false)">
            Salvar e adicionar mais
          </b-dropdown-item>
        </b-dropdown>
      </template>
    </b-modal>
    <FormFornecedor v-if="showFormBeneficiario"
                    @cadastrar="cadastrarFornecedor"
                    @hide="showFormBeneficiario = false" />
  </div>
</template>

<script>
  // Components
  import Documento from "./DocumentoLivroCaixa"
  import FormFornecedor  from "@/components/SofiaRei/Fornecedores/FormFornecedor"

  // Icons
  import outros from '@/assets/icons/outros.svg?sprite'

  // Services
  import FornecedorService from "@/services/FornecedorService"

  // Outros
  import moment from "moment"

  export default {
    name: 'FormLancamento',
    components: {
      Documento,
      FormFornecedor
    },
    props: {
      propLancamento: { type: Object, default: null},
      propTipo: {type: String, default: 'RECEITA'},
      propFornecedores: { type: Array, default: () => ([])},
      propCategorias: { type: Array, default: () => ([])}
    },
    data () {
      return {
        showFile: true,
        localData: {
          data_lancamento: moment().format('YYYY-MM-DD'),
          categoria: {},
          fornecedor: {},
          tipo: 'DESPESA',
          numero_documento: null,
          detalhamento: null,
          atos: null,
          valor: null,
          livroCaixaLancamentoArquivo: []
        },
        outros,
        categorias: [],
        fornecedores: [],
        showInputFile: true,
        deleteds: [],
        atos: [],
        money: {
          decimal: ',',
          thousands: '.',
          prefix: 'R$ ',
          suffix: '',
          precision: 2,
          masked: false
        },
        showFormBeneficiario: false
      }
    },
    computed: {
      categoriasFiltered () {
        const categorias = []

        this.propCategorias.forEach((categoria) => {
          const unique = categorias.find(cat => cat.nome === categoria.nome)

          if (!unique && categoria.ativo) categorias.push(categoria)
        })

        return categorias.filter((categoria) => !categoria.nome.toUpperCase().match('REGISTRO CIVIL') && categoria.tipo === this.localData.tipo)
      },
      fornecedoresFiltered () {
        return this.propFornecedores.filter((fornecedor) => fornecedor.ativo)
      }

    },
    mounted () {
      if (this.propLancamento) {
        this.localData = { ...this.propLancamento }
        this.localData.data_lancamento = moment(this.propLancamento.data_lancamento).format('YYYY-MM-DD')

        if (this.localData.livroCaixaLancamentoArquivo && this.localData.livroCaixaLancamentoArquivo.length) {
          this.localData.livroCaixaLancamentoArquivo = this.localData.livroCaixaLancamentoArquivo.filter(arq => !arq.deletado)
        }

        if (this.localData.livroCaixaLancamentoArquivo.length) this.showFile = false
      }
    },
    methods: {
      async saveLancamento (hide) {
        const valid = await this.$validator.validateAll()

        if (!valid) return

        this.localData.valor = this.localData.valor.replace(/\.|,|R/g, '').replace('$', '').trim()
        this.localData.valor = parseInt(this.localData.valor, 10)

        if (!this.localData.valor) this.localData.valor = '0'

        if (!this.localData.atos) this.localData.atos = '0'

        if (this.localData.categoria && this.localData.categoria.nome.toUpperCase().match('REGISTRO CIVIL')) {
          return displayMessage('error', 'Erro!', 'Categoria inválida.')
        }

        this.$emit('saveLancamento', this.localData, hide)

        if (!hide) {
          this.clearForm()
        }
      },
      async atualizarLancamento () {
        const valid = await this.$validator.validateAll()

        if (!valid) return

        this.localData.valor = this.localData.valor.replace(/\.|,|R/g, '').replace('$', '').trim()
        this.localData.valor = parseInt(this.localData.valor, 10)

        if (!this.localData.valor) this.localData.valor = '0'

        if (!this.localData.atos) this.localData.atos = '0'

        this.localData.deleteds = this.deleteds

        this.$emit('atualizarLancamento', this.localData)
      },
      clearForm () {
        this.localData = {
          data_lancamento: moment().format('YYYY-MM-DD'),
          categoria: {},
          fornecedor: {},
          tipo: 'DESPESA',
          numero_documento: null,
          detalhamento: null,
          atos: null,
          valor: null,
          livroCaixaLancamentoArquivo: []
        }

        this.$validator.reset()

        this.showFile = true
      },
      hide () {
        this.deleteds = []

        this.$emit('hide')
      },
      dragArea ($event) {
        const element = document.querySelector('.DropArea')
        element.classList.add('DropAreaDrag')
        $event.preventDefault()
      },

      dragAreaOut ($event) {
        const element = document.querySelector('.DropArea')
        element.classList.remove('DropAreaDrag')
        $event.preventDefault()
      },

      drop () {
        const element = document.querySelector('.DropArea')
        element.classList.remove('DropAreaDrag')
      },

      inputlivroCaixaLancamentoArquivo () {
        const element = document.querySelector('.fileObrigatorio')
        return element && element.livroCaixaLancamentoArquivo[0] && element.livroCaixaLancamentoArquivo[0].name || null
      },
      addArquivo (event) {
        const { files } = event.target

        for (let file of files) {
          this.localData.livroCaixaLancamentoArquivo.push(file)
        }

        // Precisamos resetar o campo para poder enviar os mesmos arquivos novamente
        // Ex.: O usuário excluiu o arquivo da lista e subiu o mesmo arquivo novamente
        event.target.value = ''

        this.showFile = false
      },
      async deleteDocumento (index) {
        const documento = this.localData.livroCaixaLancamentoArquivo[index]

        if (documento.livro_caixa_lancamento_arquivo_id) {
          const res = await displayMessage('question', 'Tem certeza que deseja excluir esse documento?')

          if (res.value) this.deleteds.push(documento.livro_caixa_lancamento_arquivo_id)
          else return
        }

        this.localData.livroCaixaLancamentoArquivo.splice(index, 1)

        if (!this.localData.livroCaixaLancamentoArquivo.length) {
          this.showFile = true
        }
      },
      changeTipo () {
        this.localData = {
          data_lancamento: moment().format('YYYY-MM-DD'),
          categoria: {},
          fornecedor: {},
          tipo: 'DESPESA',
          numero_documento: null,
          detalhamento: null,
          atos: null,
          valor: null,
          livroCaixaLancamentoArquivo: []
        }
      },
      changeCategoria (categoria) {
        if (categoria && categoria.nome) {
          this.localData.categoria = { ...categoria, ato: null}

          this.getAtos()
        } else if (categoria) {
          this.localData.categoria = {
            nome: categoria,
            ato: null
          }
        }
      },
      changeBeneficiario (beneficiario) {
        if (beneficiario && beneficiario.nome) {
          this.localData.fornecedor = { ...beneficiario, ato: null}

          this.getAtos()
        } else if (beneficiario) {
          this.localData.fornecedor = {
            nome: beneficiario
          }
        }
      },
      changeAto (ato) {
        const categoria = this.propCategorias.find(categoria => categoria.ato === ato && categoria.nome === this.localData.categoria.nome)

        if (categoria) {
          this.localData.categoria = { ...categoria }
        } else {
          this.localData.categoria = {
            nome: this.localData.categoria.nome,
            ato: ato
          }
        }
      },
      getAtos () {
        this.atos = this.propCategorias.filter(categoria => categoria.nome === this.localData.categoria.nome && !!categoria.ato).map(categoria => categoria.ato)
      },
      async cadastrarFornecedor (fornecedor) {
        try {
          loader({active: true, text: 'Cadastrando fornecedor...'})

          const res = await FornecedorService.cadastrarFornecedor(fornecedor)

          if (res) {
            displayMessage('success', 'Beneficiário cadastrado com sucesso!').then(() => {
              this.showFormBeneficiario = false
              this.$emit('reloadBeneficiarios')

              this.changeBeneficiario(res)
            })
          }

        } catch (error) {
          const message = getErrors(error)

          if (message.message && message.message.match('fornecedor_nome_cartorio_id_unique')) {
            message.message = 'Já existe um beneficiário com o mesmo nome.'
          } else if (message.message && message.message.match('fornecedor_cnpj_cartorio_id_unique')) {
            message.message = 'Já existe um benefiário com o mesmo CNPJ.'
          }

          displayMessage('error', 'Erro!', message.message)
        } finally {
          loader({active: false, text: null})
        }
      }
    }
  }
</script>

<style lang="scss">
@import "../../scss/app";
.livroCaixaLancamentoArquivoObrigatorios {
  &--fileDisabled {
    background-color: #e9ecef;
    padding: 6px 15px;
    border-radius: 2px;
    font-size: 0.875rem;
    font-weight: 400;
    color: #495057;
    border: 1px solid #ced4da;
  }
}

.DropArea {
  height: 100px;
  padding: 5px;
  background-color: #f4f4f4;
  border: 2px dashed #086AAE;
}

.DropAreaDrag {
  height: 100px;
  padding: 5px;
  background-color: #3498db;
  color: #fff;
  border-color: #086AAE;
}

.fileObrigatorio {
  height: 95px;
  padding: 5px;
  width: 94%;
  margin-top: 4px;
  background-color: #f4f4f4;
  border-color: #086AAE;
  opacity: 0;
  z-index: 10;
  position: absolute;
  top: 0;
}

  .FormLancamento {
    &_header {
      background: #074f7f;
      color: #fff;
      padding: 10px;
      font-size: 20px;
      font-weight: bold;
      border-radius: 0px;
    }

    &_content {
      border-radius: 0px;
    }

    &_body {
      padding: 10px 40px;
    }

    &_body label {
      font-size: 16px;
      font-weight: 500;
      color: #373a3c;
    }

    &_subtitle {
      border-bottom: 1px solid black ;
      margin: 10px 0px;
    }

    &_subtitle h1 {
      font-size: 18px;
      font-weight: 500;
      color: #262626;
    }
  }

</style>
